import React, { useState } from "react";

import { ContactDataContext as Context } from "./index";
import { toast } from "react-toastify";

import { createContactComunicationDataApi } from "../Api/CreateContact.js";
import { updateContactComunicationDataApi } from "../Api/UpdateContact.js";
import { showContactComunicationDataApi } from "../Api/ShowContact.js";
import {
  alertToastErrorFromResponse,
  getErrorsArrayMessageFromHtttpResponse,
} from "../../../Shared/Utils/errorUtils.js";

const ContactDataProvider = (props) => {
  const [tableData, setTableData] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);

  //get all item data
  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await showContactComunicationDataApi(id);

      let data = response.data;
      if (response.result === "success") {
        setItem(data);
      } else {
        setItem({});
        alertToastErrorFromResponse(
          "Error obteniendo datos del contacto",
          response
        );
      }
    } catch (error) {
      toast.error("Error desconocido obteniendo datos del contacto !", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createItem = async (data) => {
    let response = await createContactComunicationDataApi(data);

    if (response?.result && response?.result == "success") {
      //alertSuccess("Registro creado !");
      setApiErrors([]);

      if (response.data.length > 0) {
        let data1 = response.data[0];
        let data2 = response.data[1];
        let data3 = response.data[2];

        setItem({
          ...item,
          id: 1,
          whatsapp_1: data1.whatsapp,
          email_1: data1.email,
          whatsapp_2: data2?.whatsapp,
          email_2: data2?.email,
          whatsapp_3: data3?.whatsapp,
          email_3: data3?.email,
        });
      }
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  //edit item
  const updateItem = async (data, id) => {
    let response = await updateContactComunicationDataApi(data, id);

    if (response?.result && response?.result == "success") {
      setApiErrors([]);
      //setSuccessUpdated(true);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  const handleEdit = async (row) => {
    let editObject = tableData.find((e) => e.id === row.id);
    setItem(editObject);
    setApiErrors([]);
  };



  return (
    <Context.Provider
      value={{
        ...props,
        createItem,
        updateItem,
        setLoading,
        apiErrors,
        setItem,
        item,
        loading,
        handleEdit,
        getItem,
        setApiErrors,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default ContactDataProvider;
